export type Color = { value: string; label: string };

// DB value: 180 90% 80%
// How to use in CSS: hsl(${routine.color} / 25%) hsl(180 90% 80% / 25%)
export const RoutineColors: Color[] = [
  // Vibrant & Distinct Colors
  { value: "10 85% 75%", label: "Coral Red" }, // Coral Red
  { value: "35 90% 70%", label: "Sunset Orange" }, // Sunset Orange
  { value: "55 85% 75%", label: "Golden Yellow" }, // Golden Yellow
  { value: "85 75% 65%", label: "Lime Green" }, // Lime Green
  { value: "120 70% 60%", label: "Forest Green" }, // Forest Green
  { value: "160 80% 70%", label: "Emerald" }, // Emerald
  { value: "180 75% 65%", label: "Teal" }, // Teal
  { value: "200 85% 75%", label: "Sky Blue" }, // Sky Blue
  { value: "220 80% 70%", label: "Ocean Blue" }, // Ocean Blue
  { value: "250 75% 75%", label: "Periwinkle" }, // Periwinkle
  { value: "270 70% 70%", label: "Purple" }, // Purple
  { value: "300 75% 75%", label: "Magenta" }, // Magenta
  { value: "320 80% 75%", label: "Pink Rose" }, // Pink Rose
  { value: "340 85% 75%", label: "Hot Pink" }, // Hot Pink

  // Softer Alternatives
  { value: "15 60% 85%", label: "Peach" }, // Peach
  { value: "45 70% 80%", label: "Cream" }, // Cream
  { value: "75 50% 80%", label: "Sage" }, // Sage
  { value: "195 60% 80%", label: "Powder Blue" }, // Powder Blue
  { value: "280 55% 85%", label: "Lavender" }, // Lavender
  { value: "330 60% 85%", label: "Blush" }, // Blush
];

export const getRandomRoutineColor = () => {
  return RoutineColors[Math.floor(Math.random() * RoutineColors.length)].value;
};
